import React, { Suspense } from 'react';

export default function EsperarComponente(Component) {
  return (props) => (
    <Suspense fallback={<div>Carregando...</div>}>
      {
      // eslint-disable-next-line react/jsx-one-expression-per-line, react/jsx-props-no-spreading
      }  <Component {...props} />
    </Suspense>
  );
}
